import { render, staticRenderFns } from "./profileMainBox2.vue?vue&type=template&id=6ad92de6"
import script from "./profileMainBox2.vue?vue&type=script&lang=js"
export * from "./profileMainBox2.vue?vue&type=script&lang=js"
import style0 from "./profileMainBox2.vue?vue&type=style&index=0&id=6ad92de6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports